import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import {
    Divider,
    FormControl,
    FormControlLabel,
    FormLabel,
    Chip,
    Grid,
    Paper,
    Stack,
    RadioGroup,
    Radio,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../Button.js/SaveButton';
import ComboBox from '../Input/ComboBox';
import MutiSelect from '../Input/MutiSelect';
import NumberInput from '../Input/NumberInput';
import TextInput from '../Input/TextInput';
import Loader from '../loader/loader';
import imgDefault from './upload.png';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const StyledProductImg = styled('img')({
    // top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // position: 'absolute',
});
const DeviceModal = ({ visible = false, idGroup, dataUpdate, setVisible, fuctGet, idPermission, isEdit }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const getRefSupp = useRef();
    const [getDepartmentFlags, setGetDepartmentFlags] = useState(false);
    const [name, setName] = React.useState('');
    const [dateChecking, setdateChecking] = useState('');

    const [property, setProperty] = useState([]);
    const [propertyValue, setPropertyValue] = useState([]);
    const [getProperty, setGetProperty] = useState({});
    const [getValueProperty, setGetValueProperty] = useState({});

    const [supperlier, setsupperlier] = useState(null);
    const [price, setprice] = useState('');
    const [listProducer, setlistProducer] = useState([]);
    const [arrSupplier, setArrSupplier] = useState([]);
    const [code, setcode] = useState('');
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addCabinetFlag = React.useRef(false);

    const [status, setStatus] = useState({ label: t('take'), value: '1' });
    const [checkNotReturn, setcheckNotReturn] = useState('1');
    const [departments, setDepartments] = useState([]);
    const [department, setDepartment] = useState([]);
    const [listDepartments, setListDepartments] = useState([]);
    const [producer, setProducer] = useState({});
    const getGroup = useRef();
    const arrOptions = [
        { label: t('borrowing'), value: '0' },
        { label: t('take'), value: '1' },
    ];
    const [propertySend, setPropertySend] = useState([]);
    const monthNow = new Date().getMonth();

    const [blob, setBlob] = useState('');
    const [imgEdit, setImgEdit] = useState('');
    const imageName = useRef('');
    const dataReqImg = useRef({
        imgType: '',
        image_data: '',
        size: 0,
        encodeType: null,
    });

    const currency_user = glb_sv?.userInfo?.currency;

    useEffect(() => {
        setGetValueProperty({});
        setGetProperty({});
        imageName.current = dataUpdate.img_device;
        if (isEdit) {
            console.log('dataUpdate', dataUpdate);
            console.log('dataUpdate.img_device', dataUpdate.img_device);

            setName(dataUpdate?.device_nm);
            setcode(dataUpdate?.device_cd);
            setprice(dataUpdate?.price);
            setdateChecking(Math.abs(moment(dataUpdate?.expiry_date, 'YYYYMMDD').month() - monthNow));
            setPropertySend(dataUpdate?.properties_device);
            setProducer(dataUpdate?.producer);
            setDepartment(dataUpdate?.depart_json);
            setsupperlier({
                supplier_nm: dataUpdate?.supplier_nm,
                id: dataUpdate?.supplier_id,
            });
            setcheckNotReturn(dataUpdate?.can_grindding?.toString());
            setStatus({
                label: dataUpdate?.status_action === '0' ? t('borrowing') : t('take'),
                value: dataUpdate?.status_action || '1',
            });

            setImgEdit(dataUpdate?.img_device);
            imageName.current = dataUpdate.img_device;
        } else {
            setName('');
            setcode('');
            setdateChecking('0');
            setprice('');
            setsupperlier({});
            setPropertySend([]);
            setProducer({});
            setStatus({ label: t('take'), value: '1' });
            setDepartment([]);
            setImgEdit('');
            imageName.current = '';
        }
        setBlob('');
        setFileToUpload(null);
    }, [dataUpdate]);

    React.useEffect(() => {
        setTimeout(() => {
            getData();
            getDataDepartment();
            getDataGroups();
        }, 1000);
    }, []);

    useEffect(() => {
        if (isEdit && supperlier?.id) {
            const arrProducer = arrSupplier?.filter((supperliers) => supperliers.id === supperlier.id);
            if (arrProducer && arrProducer[0]?.producer?.length > 0) setlistProducer(arrProducer[0].producer);
        }
    }, [supperlier, arrSupplier]);

    const setListArrDepartments = (arrDepartments) => {
        if (arrDepartments?.length > 0) {
            const arr = [];
            arrDepartments.map((item) => {
                arr.push({
                    label: item.departs_nm,
                    value: item.depart_cd,
                });
            });
            setListDepartments(arr);
        }
    };

    const getDataDepartment = useCallback(() => {
        if (getDepartmentFlags) {
            return;
        }
        const InVal = [1];
        sendRequest(serviceList.getAlldepartment, InVal, getDataResultDepartment, true, timeOutFunctDepartment, 40000);
    }, []);

    const getDataResultDepartment = (reqInfoMap, message) => {
        setGetDepartmentFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDepartments(message.proc_data.rows[0].o_1);
            setListArrDepartments(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunctDepartment = (reqInfo) => {
        setGetDepartmentFlags(false);
    };

    // get groups
    const getDataGroups = useCallback(() => {
        if (getGroup.current) {
            return;
        }
        getGroup.current = true;
        const InVal = [+idGroup];
        sendRequest(serviceList.getIDgroup_devices, InVal, getDataResultGroups, true, timeOutFunctGroups, 40000);
    }, []);

    const getDataResultGroups = (reqInfoMap, message) => {
        getGroup.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setProperty(message.proc_data.rows[0].o_1[0].group_properties);
        }
    };

    const timeOutFunctGroups = (reqInfo) => {
        getGroup.current = false;
    };

    // Nh
    const getData = React.useCallback(() => {
        if (getRefSupp.current) {
            return;
        }
        getRefSupp.current = true;
        const InVal = [9999999999999999999, ''];
        sendRequest(serviceList.getAllsupplier, InVal, getDataResult, true, timeOutFunctGet, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRefSupp.current = 'false';
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setArrSupplier(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunctGet = (reqInfo) => {
        getRefSupp.current = 'false';
        toast.error(t('error.time_out'));
    };

    const [fileToUpload, setFileToUpload] = useState(null);

    const handleOnChangeFile = async (e) => {
        let file = e.target.files[0];
        if (!file) return;
        if (file.size > 50 * 1024 * 1024) {
            toast.error(t('error.file_too_large'));
            return;
        }
        setFileToUpload(file);
        try {
            const url = URL.createObjectURL(file);
            setBlob(url);
        } catch (err) {
            console.error('Error creating object URL:', err);
        }
    };

    const handleAddReport = async () => {
        if (addCabinetFlag.current) return;
        if (status.value === '0' && !dateChecking) {
            toast.error(t('error_day_checking'));
        }
        if (!name || !code || !supperlier || !price || !status?.value || !department?.length)
            return toast.error(t('error.param'));
        if (propertySend?.length === 0) return toast.error(t('err_emty_property'));

        addCabinetFlag.current = true;
        setFlagAddStat(true);

        try {
            if (fileToUpload) {
                const reader = new FileReader();
                const imageData = await new Promise((resolve, reject) => {
                    reader.onload = (evt) =>
                        resolve(evt.target.result.toString().replace(/^data:image\/\w+;base64,/, ''));
                    reader.onerror = (err) => reject(err);
                    reader.readAsDataURL(fileToUpload);
                });

                const req = await axios.post(`${glb_sv.urlPostProductImage}`, {
                    imgType: fileToUpload.type.slice(6),
                    image_data: imageData,
                    size: fileToUpload.size,
                    encodeType: 'base64',
                    typeUpload: '2',
                });

                if (req?.data?.success) {
                    imageName.current = req.data.data.imageName;
                } else {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }
                if (!imageName.current || imageName.current === '') {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }
            }

            if (isEdit) {
                const InVal = [
                    +idPermission,
                    code,
                    name,
                    supperlier.id,
                    JSON.stringify(producer),
                    status.value === '0' ? moment().add(+dateChecking, 'months').format('YYYYMMDD') : '',
                    status.value,
                    JSON.stringify(department),
                    +idGroup,
                    JSON.stringify(propertySend),
                    dataUpdate.id,
                    +price,
                    imageName.current,
                    checkNotReturn,
                ];
                sendRequest(serviceList.updateDevice, InVal, createdeviceResult, true, timeOutFunct, 40000);
            } else {
                const InVal = [
                    +idPermission,
                    code,
                    name,
                    supperlier.id,
                    JSON.stringify(producer),
                    status.value === '0' ? moment().add(+dateChecking, 'months').format('YYYYMMDD') : '',
                    status.value,
                    JSON.stringify([...department, { label: 'admin', value: 'admin' }]),
                    +idGroup,
                    JSON.stringify(propertySend),
                    +price,
                    imageName.current,
                    checkNotReturn,
                ];
                sendRequest(serviceList.createDevice, InVal, createdeviceResult, true, timeOutFunct, 40000);
            }
        } catch (error) {
            console.error('Upload error:', error);
            toast.error(t('error.system_error'));
            setFlagAddStat(false);
            addCabinetFlag.current = false;
        }
    };

    const createdeviceResult = (reqInfoMap, message) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();

            setVisible(!visible);
        }
    };

    const timeOutFunct = (reqInfo) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    const getProducer = (supperlier) => {
        setlistProducer(supperlier?.producer);
        setsupperlier(supperlier);
    };

    const handleSetProperty = (property) => {
        setGetProperty(property);
        setGetValueProperty({});
        if (property?.value?.length > 0) {
            const arr = property.value.map((item) => {
                return { label: item, value: item };
            });
            setPropertyValue(arr);
        }
    };

    const handleGetPropertySend = (property) => {
        setGetValueProperty(property);
        const check = propertySend?.filter((item) => item.label === getProperty.label) || [];
        if (check?.length > 0) {
            let index = -1;
            for (let i = 0; i < propertySend?.length; i++) {
                if (propertySend[i].label === getProperty.label) {
                    index = i;
                }
                if (index >= 0) {
                    const arrNew = propertySend;
                    arrNew[index] = {
                        ...arrNew[index],
                        label: getProperty.label,

                        value: property.value,
                    };
                    setPropertySend(arrNew);
                }
            }
        } else {
            setPropertySend([...propertySend, { label: getProperty.label, value: property.value }]);
        }
    };

    const handleDeleteValue = (item, index) => {
        propertySend.splice(index, 1);
        setPropertySend([...propertySend]);
    };

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {isEdit ? t('update_device') : t('create_device')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Loader loading={flagAddStat} />
                <Grid container spacing={2}>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('name_device')} valueChange={name} getValue={setName} required autoFocus />
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('code_device')} valueChange={code} required getValue={setcode} />
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('choose_supplier')}
                            selectOption={arrSupplier || []}
                            valueSelect={supperlier}
                            displayLabel="supplier_nm"
                            valueEqual="id"
                            getValue={getProducer}
                            required
                        />
                    </Grid>{' '}
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('producer')}
                            name={'name'}
                            disabled={supperlier?.id ? false : true}
                            selectOption={listProducer || []}
                            valueSelect={producer}
                            required
                            getValue={setProducer}
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <MutiSelect
                            label={t('choose_department')}
                            selectOption={listDepartments}
                            valueSelect={department}
                            getValue={setDepartment}
                            required
                        />
                    </Grid>
                    <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                        <NumberInput
                            label={t('price_device') + ` (${currency_user})`}
                            valueChange={price}
                            required
                            getValue={setprice}
                        />
                    </Grid>
                    <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('status_device')}
                            selectOption={arrOptions || []}
                            valueSelect={status}
                            getValue={setStatus}
                        />
                    </Grid>
                    <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                        <NumberInput
                            label={t('checking_after')}
                            valueChange={status.value === '0' ? dateChecking : ''}
                            getValue={setdateChecking}
                            required={status.value !== '0' ? false : true}
                            disabled={status.value === '0' ? false : true}
                        />
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('property')}
                            selectOption={property || []}
                            getValue={handleSetProperty}
                            valueEqual="id"
                        />
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('value_property')}
                            selectOption={propertyValue || []}
                            valueSelect={getValueProperty}
                            disabled={getProperty?.label ? false : true}
                            valueEqual="value"
                            getValue={handleGetPropertySend}
                        />
                    </Grid>
                    <Grid
                        item
                        xl={4}
                        md={12}
                        sm={12}
                        style={{ width: '100%', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <FormControlLabel
                                    value="1"
                                    control={
                                        <Radio
                                            checked={checkNotReturn === '1'}
                                            onClick={() => {
                                                setcheckNotReturn('1');
                                            }}
                                        />
                                    }
                                    // checked={valueCheck.notReturn}
                                    label={t('can_grinding')}
                                />
                                <FormControlLabel
                                    value="0"
                                    control={
                                        <Radio
                                            checked={checkNotReturn === '0'}
                                            onClick={() => setcheckNotReturn('0')}
                                        />
                                    }
                                    // checked={valueCheck.return}
                                    label={t('cannot_grinding')}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item sm={12} style={{ width: '100%' }}>
                        <Paper
                            spacing={1}
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                            }}
                        >
                            {propertySend?.length > 0 &&
                                propertySend.map((item, idx) => (
                                    <Chip
                                        sx={{ width: 'fit-content', marginLeft: 0.5, marginTop: 0.5 }}
                                        key={idx}
                                        variant="outlined"
                                        color="primary"
                                        label={item?.label + ': ' + item.value}
                                        onDelete={() => handleDeleteValue(item, idx)}
                                    />
                                ))}
                        </Paper>
                    </Grid>
                    <Grid
                        item
                        xl={12}
                        md={12}
                        sm={12}
                        style={{ width: '100%' }}
                        // display={'flex'}
                        // justifyContent={'right'}
                    >
                        <input
                            type="file"
                            name="upload"
                            accept="image/png,image/jpg,image/jpeg"
                            onChange={handleOnChangeFile}
                            id="upload"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="upload" className={'upload-img-report col-form-label'}>
                            <span style={{ color: '#888', fontSize: '14px' }}>{t('img_device')} </span>
                            <Stack direction="row" spacing={2}>
                                {isEdit && !blob ? (
                                    <img src={`${glb_sv.urlGetProductImage(imgEdit)}`} alt="" />
                                ) : (
                                    <img src={blob ? blob : imgDefault} alt="" />
                                )}
                            </Stack>
                        </label>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    disabled={flagAddStat}
                    onClick={() => {
                        setVisible(!visible);
                        setBlob('');
                        setFileToUpload(null);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                <ButtonAction disabled={flagAddStat} onClick={handleAddReport} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default DeviceModal;
